// apps/codeframe/src/motion/drivers.ts
import type { MotionTimeline, Trigger } from '../store/types';
import { resolveCfNode } from '../store/slot-schema';
import type { MotionPlayer } from './player';

const EVENT: Record<Trigger['on'], keyof HTMLElementEventMap> = {
  hover: 'mouseenter', leave: 'mouseleave', click: 'click', focus: 'focusin',
};

function run(p: MotionPlayer, tr: Trigger) {
  switch (tr.do) {
    case 'play': p.play(); break;
    case 'reverse': p.reverse(); break;
    case 'toggle': p.playing ? p.pause() : p.play(); break;
    case 'goto': if (tr.segment) p.goto(tr.segment); break;
  }
}

/** Attach trigger listeners; returns a cleanup that removes them all. */
export function wireTriggers(root: HTMLElement, tl: MotionTimeline, p: MotionPlayer): () => void {
  const offs: Array<() => void> = [];
  for (const tr of tl.playback.triggers ?? []) {
    const target = (tr.target ? resolveCfNode(root, tr.target) as HTMLElement | null : null) ?? root;
    const type = EVENT[tr.on];
    const handler = () => run(p, tr);
    target.addEventListener(type, handler);
    offs.push(() => target.removeEventListener(type, handler));
  }
  return () => offs.forEach((off) => off());
}
